module.exports = __webpack_public_path__ + "img/end_title1.01bc75e0.png";